import { Controller, Get, Post, Put, Param, Body, Delete, Query } from '@nestjs/common';
import { ClientsService } from './clients.service';
import { CreateClientsDto, UpdateClientsDto } from '@crm/dto';
import { ApiResponseInterface } from '@crm/interface';

@Controller('clients')
export class ClientsController {
  constructor(private readonly clientsService: ClientsService) {}

  // Get all clients (management)
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.clientsService.getAll();
  }

  // Get clients for supervisor role
  @Get('supervisor')
  async getForSupervisor(): Promise<ApiResponseInterface> {
    return this.clientsService.getForSupervisor();
  }

  // Get clients by user ID (creator)
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.clientsService.getByUserId(userId);
  }

  // Get client by ID
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.clientsService.getById(id);
  }

  // Create new client
  @Post()
  async create(@Body() dto: CreateClientsDto): Promise<ApiResponseInterface> {
    return this.clientsService.create(dto);
  }

  // Update existing client
  @Put()
  async update(@Body() dto: UpdateClientsDto): Promise<ApiResponseInterface> {
    return this.clientsService.update(dto);
  }

  // Soft delete client
  @Delete()
  async softDelete(@Body() dto: UpdateClientsDto): Promise<ApiResponseInterface> {
    return this.clientsService.softDelete(dto);
  }
}